<script lang="ts" module>
  export type Plan = {
    id: string;
    name: string;
    description: string | null;
    amount: number;
    currency: string;
    interval: string;
    trial_period_days: number;
    features: string[];
  };
</script>

<script lang="ts">
  import { Button } from "$lib/components/ui/button/index.js";
  import { formatMoney } from "$lib/pricing";

  interface Props {
    plans: Plan[];
    mode?: "public" | "customer";
    onSelect: (planId: string) => void;
    busyPlanId?: string | null;
  }

  let { plans, mode = "public", onSelect, busyPlanId = null }: Props = $props();

  const ctaLabel = $derived(mode === "public" ? "Get started" : "Subscribe");

  function formatPrice(plan: Plan): string {
    const per = plan.interval === "year" ? "/yr" : plan.interval === "month" ? "/mo" : "";
    return `${formatMoney(plan.amount, plan.currency)}${per}`;
  }
</script>

<div class="grid gap-4 grid-cols-[repeat(auto-fit,minmax(min(15rem,100%),1fr))]">
  {#each plans as plan (plan.id)}
    <div class="flex flex-col gap-3 rounded-xl border border-border bg-card p-6 shadow-sm">
      <div class="space-y-1">
        <p class="text-lg font-semibold">{plan.name}</p>
        {#if plan.description}
          <p class="text-sm text-muted-foreground">{plan.description}</p>
        {/if}
      </div>

      <p class="text-2xl font-bold">{formatPrice(plan)}</p>

      {#if plan.trial_period_days > 0}
        <p class="text-sm text-muted-foreground">{plan.trial_period_days}-day free trial</p>
      {/if}

      {#if plan.features.length > 0}
        <ul class="flex flex-col gap-1.5 text-sm">
          {#each plan.features as feature (feature)}
            <li class="flex items-start gap-2">
              <span aria-hidden="true" class="mt-0.5 text-primary">✓</span>
              <span>{feature}</span>
            </li>
          {/each}
        </ul>
      {/if}

      <Button
        onclick={() => onSelect(plan.id)}
        disabled={busyPlanId === plan.id}
        class="mt-auto min-h-11 w-full"
      >
        {busyPlanId === plan.id ? "Starting…" : ctaLabel}
      </Button>
    </div>
  {/each}
</div>
